import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../api";
import ProductFeed from "../components/ProductFeed";

export default function SearchResults() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const q = params.get("q") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/products", { params: { search: q } })
      .then((r) => setProducts(r.data.products))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="max-w-5xl mx-auto" data-testid="search-page">
      <div className="flex items-center gap-3 px-4 pt-5 pb-2">
        <button data-testid="back-button" onClick={() => navigate(-1)} aria-label="Torna indietro" className="p-2 -ml-2 text-[#2C2C2C] hover:opacity-60 transition-opacity duration-200">
          <ArrowLeft size={20} strokeWidth={1.5} />
        </button>
      </div>
      <div className="text-center mb-10 px-4">
        <h1 className="font-display text-3xl text-[#2C2C2C]" data-testid="search-title">Risultati per “{q}”</h1>
        <div className="gold-line w-24 mx-auto mt-4" />
      </div>
      <div className="pb-20">
        <ProductFeed products={products} loading={loading} />
      </div>
    </div>
  );
}
